<div class="reports-container">
  <div class="reports-header">
    <h1>
      <i class="fas fa-chart-bar"></i>
      Reports
    </h1>
    <button class="btn btn-secondary" routerLink="/admin/dashboard">
      <i class="fas fa-arrow-left"></i>
      Back to Dashboard
    </button>
  </div>

  <!-- Tabs -->
  <div class="tabs-section">
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'orders'"
      (click)="switchTab('orders')">
      <i class="fas fa-shopping-cart"></i>
      Orders Report
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'appointments'"
      (click)="switchTab('appointments')">
      <i class="fas fa-calendar-check"></i>
      Appointments Report
    </button>
  </div>

  <!-- Revenue Summary -->
  <!-- <div class="revenue-summary">
    <div class="revenue-card">
      <div class="revenue-icon">
        <i class="fas fa-rupee-sign"></i>
      </div>
      <div class="revenue-content">
        <h3>Total Revenue (Received)</h3>
        <p class="revenue-amount">{{ formatCurrency(totalRevenue) }}</p>
        <span class="revenue-label">From delivered & paid orders</span>
      </div>
    </div>
    <div class="revenue-card filtered">
      <div class="revenue-icon">
        <i class="fas fa-filter"></i>
      </div>
      <div class="revenue-content">
        <h3>Filtered Revenue (Received)</h3>
        <p class="revenue-amount">{{ formatCurrency(filteredRevenue) }}</p>
        <span class="revenue-label">From {{ filteredOrders.length }} filtered orders</span>
      </div>
    </div>
    <div class="revenue-card" style="border-left-color: #ffc107;">
      <div class="revenue-icon" style="background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);">
        <i class="fas fa-shopping-cart"></i>
      </div>
      <div class="revenue-content">
        <h3>Total Order Value</h3>
        <p class="revenue-amount">{{ formatCurrency(filteredOrderValue) }}</p>
        <span class="revenue-label">All filtered orders (including pending)</span>
      </div>
    </div>
  </div> -->

  <!-- Orders Section -->
  @if (activeTab === 'orders') {
  <!-- Date Filters -->
  <div class="filters-section">
    <div class="filters-card">
      <h3>
        <i class="fas fa-calendar-alt"></i>
        Date Filters
      </h3>
      <div class="filter-controls">
        <div class="filter-group">
          <label for="startDate">Start Date</label>
          <input 
            type="date" 
            id="startDate" 
            [(ngModel)]="startDate" 
            [max]="maxDate"
            (change)="onDateFilterChange()"
            class="form-control"
          />
        </div>
        <div class="filter-group">
          <label for="endDate">End Date</label>
          <input 
            type="date" 
            id="endDate" 
            [(ngModel)]="endDate" 
            [max]="maxDate"
            (change)="onDateFilterChange()"
            class="form-control"
          />
        </div>
        <div class="filter-actions">
          <button class="btn btn-outline-secondary" (click)="clearFilters()">
            <i class="fas fa-times"></i>
            Clear Filters
          </button>
          <button class="btn btn-success" (click)="exportToExcel()" [disabled]="filteredOrders.length === 0">
            <i class="fas fa-file-excel"></i>
            Export to Excel
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Orders Table -->
  <div class="orders-section">
    <div class="orders-card">
      <div class="card-header">
        <h3>
          <i class="fas fa-shopping-cart"></i>
          Orders ({{ filteredOrders.length }})
        </h3>
      </div>
      
      @if (isLoading) {
      <div class="loading-state">
        <i class="fas fa-spinner fa-spin fa-2x"></i>
        <p>Loading orders...</p>
      </div>
      } @else if (filteredOrders.length === 0) {
      <div class="empty-state">
        <i class="fas fa-inbox fa-3x"></i>
        <p>No orders found</p>
        <small>Try adjusting your date filters</small>
      </div>
      } @else {
      <div class="table-responsive">
        <table class="orders-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Date</th>
              <th>Customer</th>
              <th>Mobile</th>
              <th>Products</th>
              <th>Sub Category</th>
              <th>Amount</th>
              <th>Discount</th>
              <th>Final Amount</th>
              <th>Status</th>
              <th>Payment</th>
            </tr>
          </thead>
          <tbody>
            @for (order of getPaginatedOrders(); track order.id) {
            <tr>
              <td>
                <span class="order-id">{{ order.id }}</span>
              </td>
              <td>{{ formatDate(order.orderDate) }}</td>
              <td>{{ order.userName || 'N/A' }}</td>
              <td>{{ order.userMobile || 'N/A' }}</td>
              <td>
                <div class="products-list">
                  @for (product of order.products; track product.id || $index) {
                  <span class="product-tag">
                    {{ product.name || 'N/A' }}
                  </span>
                  }
                </div>
              </td>
              <td>
                <div class="products-list">
                  @for (product of order.products; track product.id || $index) {
                  <span class="product-tag">
                    {{ product.selectedCategoryName || product.categoryName || 'N/A' }}
                  </span>
                  }
                </div>
              </td>
              <td>{{ formatCurrency(order.totalAmount || 0) }}</td>
              <td>{{ formatCurrency(order.discountAmount || 0) }}</td>
              <td class="final-amount">{{ formatCurrency(getOrderTotal(order)) }}</td>
              <td>
                <span class="status-badge" [style.background-color]="getStatusColor(order.status)">
                  {{ order.status | titlecase }}
                </span>
              </td>
              <td>
                <div class="payment-info">
                  <span class="payment-method">{{ order.paymentMethod || 'N/A' }}</span>
                  <span class="payment-status" [class.completed]="order.paymentStatus === 'completed'">
                    {{ getPaymentStatusText(order.paymentStatus || 'pending') }}
                  </span>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      
      <!-- Pagination for Orders -->
      @if (filteredOrders.length > ordersPerPage) {
      <div class="pagination-container">
        <div class="pagination-info">
          Showing {{ (currentOrdersPage - 1) * ordersPerPage + 1 }} to {{ Math.min(currentOrdersPage * ordersPerPage, filteredOrders.length) }} of {{ filteredOrders.length }} orders
        </div>
        <div class="pagination-controls">
          <button 
            class="pagination-btn" 
            (click)="previousOrdersPage()" 
            [disabled]="currentOrdersPage === 1">
            <i class="fas fa-chevron-left"></i>
            Previous
          </button>
          <div class="page-numbers">
            @for (page of [].constructor(totalOrdersPages); track $index) {
            <button 
              class="page-number" 
              [class.active]="currentOrdersPage === $index + 1"
              (click)="goToOrdersPage($index + 1)">
              {{ $index + 1 }}
            </button>
            }
          </div>
          <button 
            class="pagination-btn" 
            (click)="nextOrdersPage()" 
            [disabled]="currentOrdersPage === totalOrdersPages">
            Next
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      }
      }
    </div>
  </div>
  }

  <!-- Appointments Section -->
  @if (activeTab === 'appointments') {
  <!-- Date Filters -->
  <div class="filters-section">
    <div class="filters-card">
      <h3>
        <i class="fas fa-calendar-alt"></i>
        Date Filters
      </h3>
      <div class="filter-controls">
        <div class="filter-group">
          <label for="appointmentStartDate">Start Date</label>
          <input 
            type="date" 
            id="appointmentStartDate" 
            [(ngModel)]="appointmentStartDate" 
            [max]="maxDate"
            (change)="onAppointmentDateFilterChange()"
            class="form-control"
          />
        </div>
        <div class="filter-group">
          <label for="appointmentEndDate">End Date</label>
          <input 
            type="date" 
            id="appointmentEndDate" 
            [(ngModel)]="appointmentEndDate" 
            [max]="maxDate"
            (change)="onAppointmentDateFilterChange()"
            class="form-control"
          />
        </div>
        <div class="filter-actions">
          <button class="btn btn-outline-secondary" (click)="clearAppointmentFilters()">
            <i class="fas fa-times"></i>
            Clear Filters
          </button>
          <button class="btn btn-success" (click)="exportAppointmentsToExcel()" [disabled]="filteredAppointments.length === 0">
            <i class="fas fa-file-excel"></i>
            Export to Excel
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Appointments Table -->
  <div class="orders-section">
    <div class="orders-card">
      <div class="card-header">
        <h3>
          <i class="fas fa-calendar-check"></i>
          Appointments ({{ filteredAppointments.length }})
        </h3>
      </div>
      
      @if (isLoadingAppointments) {
      <div class="loading-state">
        <i class="fas fa-spinner fa-spin fa-2x"></i>
        <p>Loading appointments...</p>
      </div>
      } @else if (filteredAppointments.length === 0) {
      <div class="empty-state">
        <i class="fas fa-inbox fa-3x"></i>
        <p>No appointments found</p>
        <small>Try adjusting your date filters</small>
      </div>
      } @else {
      <div class="table-responsive">
        <table class="orders-table">
          <thead>
            <tr>
              <th>Appointment ID</th>
              <th>Date</th>
              <th>Name</th>
              <th>Age</th>
              <th>Gender</th>
              <th>WhatsApp Number</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            @for (appointment of getPaginatedAppointments(); track appointment.id) {
            <tr>
              <td>
                <span class="order-id">{{ appointment.id }}</span>
              </td>
              <td>{{ formatDate(appointment.createdAt) }}</td>
              <td>{{ appointment.name || 'N/A' }}</td>
              <td>{{ appointment.age || 'N/A' }}</td>
              <td>{{ appointment.gender || 'N/A' }}</td>
              <td>{{ appointment.whatsappNumber || 'N/A' }}</td>
              <td>{{ appointment.address || 'N/A' }}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      
      <!-- Pagination for Appointments -->
      @if (filteredAppointments.length > appointmentsPerPage) {
      <div class="pagination-container">
        <div class="pagination-info">
          Showing {{ (currentAppointmentsPage - 1) * appointmentsPerPage + 1 }} to {{ Math.min(currentAppointmentsPage * appointmentsPerPage, filteredAppointments.length) }} of {{ filteredAppointments.length }} appointments
        </div>
        <div class="pagination-controls">
          <button 
            class="pagination-btn" 
            (click)="previousAppointmentsPage()" 
            [disabled]="currentAppointmentsPage === 1">
            <i class="fas fa-chevron-left"></i>
            Previous
          </button>
          <div class="page-numbers">
            @for (page of [].constructor(totalAppointmentsPages); track $index) {
            <button 
              class="page-number" 
              [class.active]="currentAppointmentsPage === $index + 1"
              (click)="goToAppointmentsPage($index + 1)">
              {{ $index + 1 }}
            </button>
            }
          </div>
          <button 
            class="pagination-btn" 
            (click)="nextAppointmentsPage()" 
            [disabled]="currentAppointmentsPage === totalAppointmentsPages">
            Next
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      }
      }
    </div>
  </div>
  }
</div>
